// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--L1ZnK","slogan":"header-module--slogan--ZYtL0","more":"header-module--more--2x0M8"};